export {default} from './TitleMdLg';


// WEBPACK FOOTER //
// ./src/components/Project/TitleMdLg/index.js